/**
 * Ember Zendesk Localization Adapter
 *
 * This adapter bridges the Ember Zendesk Localization service to the framework-agnostic
 * ZendeskLocalization interface from @repo/poly-hooks, allowing React components in
 * Ember apps to use Zendesk localization without depending on Ember services directly.
 */

import type { ZendeskLocalization } from '@repo/poly-hooks/zendesk-localization';

export function createEmberZendeskLocalizationAdapter(
  // oxlint-disable-next-line typescript/no-explicit-any
  zendeskLocalizationService: any
): ZendeskLocalization {
  // Read lazily: Ember changes the country after the adapter is created.
  const getBaseUrl = (): string => {
    // oxlint-disable-next-line typescript/consistent-type-assertions, typescript/no-unsafe-member-access
    const country = zendeskLocalizationService.organizationCountry as string;
    // oxlint-disable-next-line typescript/consistent-type-assertions, typescript/no-unsafe-member-access
    const locale = zendeskLocalizationService.userLocale as string;
    return `https://support-${country}.qonto.com/hc/${locale}`;
  };

  return {
    get organizationCountry(): string {
      // oxlint-disable-next-line typescript/consistent-type-assertions, typescript/no-unsafe-member-access
      return zendeskLocalizationService.organizationCountry as string;
    },
    set organizationCountry(country: string) {
      // oxlint-disable-next-line typescript/no-unsafe-member-access
      zendeskLocalizationService.organizationCountry = country;
    },
    get getLocalizedHelpCenter(): string {
      return getBaseUrl();
    },
    getLocalizedArticle: (articleSlug: string | number) =>
      `${getBaseUrl()}/articles/${articleSlug}`,
    getLocalizedCategory: (categorySlug: string | number) =>
      `${getBaseUrl()}/categories/${categorySlug}`,
  };
}
